module.exports = __webpack_public_path__ + "img/winnings-napi.67fc67d0.png";